import type { Provider } from '@angular/core';
import { InjectionToken } from '@angular/core';

export interface CloudinaryImageConfig {
    baseUrl: string;
}

export const CLOUDINARY_IMAGE_CONFIG = new InjectionToken<CloudinaryImageConfig>('CLOUDINARY_IMAGE_CONFIG');

export function provideCloudinaryImageConfig(config: CloudinaryImageConfig): Provider {
    return { provide: CLOUDINARY_IMAGE_CONFIG, useValue: config };
}
